import _ from "lodash";

/**
 * Generates an object of skip flags for GraphQL queries based on configured columns.
 *
 * For each flag in columnTypeMapToSkipFlags, sets the flag to true by default (skipping the query for that column type).
 * If a column type is present in configuredColumns, its corresponding skip flag is set to false (do not skip).
 *
 * @param {Array<string>} configuredColumns - List of column types currently configured/displayed.
 * @param {Object} columnTypeMapToSkipFlags - Mapping of column type to skip flag name (e.g., { student: 'skipStudent', teacher: 'skipTeacher' }).
 * @returns {Object} skipFlags - Object with skip flag names as keys and boolean values indicating whether to skip the query for each column type.
 *
 * @example
 * const configuredColumns = ['student', 'teacher'];
 * const columnTypeMapToSkipFlags = { student: 'skipStudent', teacher: 'skipTeacher', admin: 'skipAdmin' };
 * // Returns: { skipStudent: false, skipTeacher: false, skipAdmin: true }
 * getQuerySkipFlagsForConfiguredColumns({ configuredColumns, columnTypeMapToSkipFlags });
 */
export const getQuerySkipFlagsForConfiguredColumns = ({
  configuredColumns = [],
  columnTypeMapToSkipFlags = new Map(),
}) => {
  //marks all skip flags as true, assuming the required columns is not present in dataGrid hence not required
  const skipFlags = _.reduce(
    _.values(columnTypeMapToSkipFlags),
    (acc, flagName) => {
      acc[flagName] = true;
      return acc;
    },
    {}
  );

  //marks the skip flags as false, if the column is present in current columns
  _.forEach(configuredColumns, columnType => {
    const flagName = columnTypeMapToSkipFlags[columnType];
    if (flagName) {
      skipFlags[flagName] = false;
    }
  });

  return skipFlags;
};
